import { h, Component } from 'preact';
import s from 'components/shared/vimeo/vimeo.sss';
import { joinClasses } from 'utils/utils';
import Store from 'store/store';
import * as actions from 'store/actions';

export default class Vimeo extends Component {
	constructor(props) {
		super(props);

		if (props.autoplay && !props.muted) {
			console.error('Vimeo won\'t autoplay if not muted');
		}

		this.tracked = {};

		this.playerReady = this.playerReady.bind(this);
		this.onProgress  = this.onProgress.bind(this);
		this.onLoad      = this.onLoad.bind(this);
	}

	componentDidMount() {
		const { vimeoID } = this.props;
		this.initVimeo(vimeoID);
	}

	componentWillUnmount() {
		if (!this.player) {
			return;
		}
		
		this.player.off('loaded');
		this.player.off('timeupdate');
		this.player.off('ended');
		this.player.destroy();
	}

	initVimeo(videoId) {
		if (typeof window === 'undefined') {
			return;
		}
		if (window.Vimeo && window.Vimeo.Player) {
			return this.loadPlayer(videoId);
		}
		if (!window.VimeoLoader) {
			window.VimeoLoader = new Promise((resolve, reject) => {
				const tag = document.createElement('script');
				tag.src = 'https://player.vimeo.com/api/player.js';
				document.body.appendChild(tag);
				tag.onload = resolve;
				tag.onerror = reject;
			});
		}
		return window.VimeoLoader.then(() => {
			this.loadPlayer(videoId);
		}).catch(() => Store.emit(actions.API_ERROR, 'Vimeo', 'Error loading Vimeo player'));
	}

	playerReady() {
		if (typeof this.props.onPlayerReady === 'function') {
			this.props.onPlayerReady();
		}
	}

	loadPlayer(videoId) {
		const vimeoIframe = document.getElementById(videoId);
		this.player = new window.Vimeo.Player(vimeoIframe);
		this.player.on('loaded', setTimeout(this.onLoad, 0));
		this.player.on('timeupdate', this.onProgress);
		this.player.on('ended', this.onEnded);
		this.player.loadVideo(videoId).catch(error => Store.emit(actions.API_ERROR, 'Vimeo', error));
	}

	onLoad() {
		const { autoplay } = this.props;
		this.playerReady();
		if (autoplay) {
			this.player.play();
		}
	}

	onProgress({ percent }) {
		if (this.props.useTracking) {
			[0, 25, 50, 75, 95].forEach(v => {
				if (this.tracked[v]) return;
				if (percent > v / 100) {
					let progress = v;
					// Vimeo API 'ended' event not reliable
					if (v === 95) progress = 100;
					Store.emit(actions.VIMEO_VIDEO_PROGRESS, progress, this.props.vimeoID, this.props.isClosableTrailer);
					this.tracked[v] = true;
				}
			});
		}
	}

	onEnded() {
		const { onEndedHandler } = this.props;
		if (onEndedHandler) {
			onEndedHandler();
		}
	}

	render(props) {
		const {
			vimeoID = '',
			class: className = '',
			iframeClass = '',
			autoplay = false,
			muted = false,
			maintainAspectRatio = false,
			captionsCode = '',
			...attributes
		} = props;

		const autoplayParam = autoplay ? 1 : 0;
		const mutedParam = muted ? 1 : 0;

		return(
			<div class={joinClasses(s.wrapper, className, maintainAspectRatio ? s.maintainAspectRatio : s.full)}>
				<iframe
					id={vimeoID}
					class={iframeClass}
					src={`https://player.vimeo.com/video/${vimeoID}?texttrack=${captionsCode}&autoplay=${autoplayParam}&muted=${mutedParam}`}
					frameborder="0"
					allow="autoplay"
					fullscreen
					allowfullscreen
					{...attributes}
				/>
			</div>
		);
	}
}
